export const getTimeLastRefresh = state => state.lastTimeRefresh;



/** WEBPACK FOOTER **
 ** ./src/members/state/lastTimeRefresh/selectors.js
 **/